import { RELEVANCE_SORT_FIELD_NAME } from '~/constants/relevanceSortFieldName';

type GetViewSortingMenuOptionsParams = {
  sortingFieldNames: readonly string[];
  allowCustomSorting: boolean;
  hasSearchParams: boolean;
};

export const getViewSortingMenuOptions = ({
  sortingFieldNames,
  allowCustomSorting,
  hasSearchParams,
}: GetViewSortingMenuOptionsParams): string[] => {
  const persistableFieldNames = sortingFieldNames.filter(
    (name) => name !== 'customSort' && name !== RELEVANCE_SORT_FIELD_NAME,
  );

  return [
    ...(hasSearchParams ? [RELEVANCE_SORT_FIELD_NAME] : []),
    ...persistableFieldNames,
    ...(allowCustomSorting ? ['customSort'] : []),
  ];
};
